
import { Point } from './interaction-data.type';

export const calculateSvgPpi = (svgElement: SVGSVGElement): Point | null => {
	const viewBoxAttr = svgElement.getAttribute('viewBox');
	if (!viewBoxAttr) return null;

	const [, , viewBoxWidth, viewBoxHeight] = viewBoxAttr.trim().split(/[\s,]+/).map(Number);

	const computedStyle = window.getComputedStyle(svgElement);

	const parseInches = (value: string): number => {
		if (value.endsWith('in')) return parseFloat(value);
		if (value.endsWith('cm')) return parseFloat(value) / 2.54;
		if (value.endsWith('mm')) return parseFloat(value) / 25.4;
		if (value.endsWith('pt')) return parseFloat(value) / 72;
		if (value.endsWith('px')) return parseFloat(value) / 96;
		return parseFloat(value) / 96;
	};

	const widthIn = parseInches(svgElement.getAttribute('width') ?? computedStyle.width);
	const heightIn = parseInches(svgElement.getAttribute('height') ?? computedStyle.height);

	if (!widthIn || !heightIn) return null;

	const ppiX = viewBoxWidth / widthIn;
	const ppiY = viewBoxHeight / heightIn;

	return { x: Math.trunc(ppiX), y: Math.trunc(ppiY) };
};
